<template>
    <div class="inviteregis-container">
        <div class="regis-info">
            <div class="userNamePosition">{{ nickName }}</div>
            <div class="swiper" style="margin-top: -50px">
                <div class="swiper-container" id="banner">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img
                                style="border-radius: 10px"
                                class="swiper-slide"
                                src="../assets/rotationImgOne.png"
                                alt=""
                            />
                        </div>
                        <div class="swiper-slide">
                            <img
                                style="border-radius: 10px"
                                class="swiper-slide"
                                src="../assets/rotationImgTwo.png"
                                alt=""
                            />
                        </div>
                        <div class="swiper-slide">
                            <img
                                style="border-radius: 10px"
                                class="swiper-slide"
                                src="../assets/rotationImgThree.png"
                                alt=""
                            />
                        </div>
                        <div class="swiper-slide">
                            <img
                                style="border-radius: 10px"
                                class="swiper-slide"
                                src="../assets/rotationImgFour.png"
                                alt=""
                            />
                        </div>
                        <div class="swiper-slide">
                            <img
                                style="border-radius: 10px"
                                class="swiper-slide"
                                src="../assets/rotationImgFive.png"
                                alt=""
                            />
                        </div>
                        <!--                        <div class="swiper-slide" v-for="(item, index) in imgList" :key="index">-->
                        <!--                            <img-->
                        <!--                                style="border-radius: 10px;"-->
                        <!--                                class="swiper-slide"-->
                        <!--                                :src="picUrl+item.images"-->
                        <!--                                alt=""-->
                        <!--                            />-->
                        <!--                        </div>-->
                    </div>
                </div>
            </div>
            <div class="swiper-button-next">
                <img class="buttonNextTrue" src="../assets/right.png" />
            </div>
            <div class="swiper-button-prev">
                <img class="buttonPrevTrue" src="../assets/left.png" />
            </div>
            <div class="form-container">
                <van-field
                    v-model="form.username"
                    placeholder="请输入手机号"
                    type="tel"
                ></van-field>
                <van-field v-model="code" placeholder="请输入图形验证码">
                    <template #extra>
                        <img :src="imgUrl" @click="getCode" />
                    </template>
                </van-field>
                <van-field
                    v-model="form.checkCode"
                    :maxlength="4"
                    placeholder="请输入短信验证码"
                >
                    <template #extra>
                        <span
                            class="sendBtn"
                            @click="sendMsg"
                            v-text="
                                (!state.smsSendBtn && '获取验证码') ||
                                state.time + ' s'
                            "
                            >发送验证码</span
                        >
                    </template>
                </van-field>
                <van-button class="register-btn" @click="handleRegis"
                    >为TA助力</van-button
                >
            </div>
            <!--            <van-popup round v-model="show"-->
            <!--                       :style="{ backgroundColor: 'transparent', width: '300px', height: '600px' }">-->
            <!--                <div class="helpSuccess">-->
            <!--                    <img style="width: 300px; height: 500px;" src="../assets/helpSuccess2.png">-->
            <!--                </div>-->
            <!--                <van-button @click="goToDownload" class="goToDownload">我也要开盲盒</van-button>-->
            <!--            </van-popup>-->
        </div>
        <div class="winningRecordTrue">
            <div>
                <span style="color: #ff8d00; font-size: 16px">幸运用户</span>
            </div>
            <div>
                <van-swipe
                    vertical
                    class="notice-swipe"
                    :autoplay="9000"
                    :show-indicators="false"
                >
                    <van-swipe-item
                        v-for="item in activityRecordOuter"
                        :key="item.id"
                        class="list-row"
                    >
                        <div>
                            <van-col span="6" class="longText">{{
                                item[0].gmtCreate
                            }}</van-col>
                            <van-col span="10" class="longText">{{
                                item[0].userNickname
                            }}</van-col>
                            <van-col span="8" class="longText">{{
                                item[0].activityProductName
                            }}</van-col>
                        </div>
                        <div>
                            <van-col span="6" class="longText">{{
                                item[1].gmtCreate
                            }}</van-col>
                            <van-col span="10" class="longText">{{
                                item[1].userNickname
                            }}</van-col>
                            <van-col span="8" class="longText">{{
                                item[1].activityProductName
                            }}</van-col>
                        </div>
                        <div>
                            <van-col span="6" class="longText">{{
                                item[2].gmtCreate
                            }}</van-col>
                            <van-col span="10" class="longText">{{
                                item[2].userNickname
                            }}</van-col>
                            <van-col span="8" class="longText">{{
                                item[2].activityProductName
                            }}</van-col>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
    </div>
</template>
<script>
import {
    fetchCode,
    fetchLogin,
    getSmsCaptcha,
    checkPhone,
    getActivityRecord,
    getUserName,
} from "../services/common";
import { Notify } from "vant";
import Swiper from "swiper";

export default {
    data() {
        return {
            picUrl: "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/",
            form: {
                username: "",
                checkCode: "",
                invitationCode: "",
                type: 0,
                registerActivityId: "",
            },
            userId: "",
            nickName: "",
            code: "",
            imgUrl: "",
            state: {
                time: 60,
                smsSendBtn: false,
            },
            imgList: [],
            activityRecord: [],
            activityRecordOuter: [],
            activityId: "",
            show: false,
            show1: false,
        };
    },
    mounted() {
        const data = this.$route.query;
        this.form.invitationCode = data.code;
        // 用户id
        this.userId = data.userName;
        this.activityId = data.activityId;
        this.getCode();
        /* eslint-disable no-new */
        this.$nextTick(() => {
            this.initSwiper();
        });
    },
    watch: {
        userId: {
            handler(newVal, oldVal) {
                this.getUserName();
            },
        },
        activityId: {
            handler(newVal, oldVal) {
                // this.getActivityImg()
                this.getActivityRecord();
            },
        },
    },
    methods: {
        initSwiper() {
            setTimeout(() => {
                new Swiper(".swiper-container", {
                    centeredSlides: true,
                    slidesPerView: 2,
                    observer: true,
                    observeParents: true,
                    autoplay: {
                        disableOnInteraction: false,
                        stopOnLastSlide: false,
                    },
                    loop: true,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                        hide: true,
                    },
                });
            }, 300);
        },
        // showwww () {
        //     this.show = true
        //     this.$nextTick(() => {
        //         this.initSwiper()
        //     })
        // },
        getUserName() {
            getUserName(this.userId).then((res) => {
                if (res.code === 0) {
                    this.nickName = res.data.nickName;
                }
            });
        },
        goToDownload() {
            this.$router.push({ path: "inviteRegisterSuccess" });
        },
        // showPopup () {
        //     this.show = true
        //     this.show1 = true
        // },
        getActivityRecord() {
            getActivityRecord({
                activityId: this.activityId,
                activityProductType: 10,
                current: 1,
                size: 9,
            }).then((res) => {
                if (res.code === 0) {
                    this.activityRecord = res.data.records;
                    if (this.activityRecord.length % 3 === 0) {
                        for (
                            var i = 0;
                            i < this.activityRecord.length;
                            i = i + 3
                        ) {
                            const list = [];
                            list.push(this.activityRecord[i]);
                            list.push(this.activityRecord[i + 1]);
                            list.push(this.activityRecord[i + 2]);
                            this.activityRecordOuter.push(list);
                        }
                    } else {
                        const count = this.activityRecord.length % 3;
                        if (count === 1) {
                            this.activityRecord.push({
                                gmtCreate: "",
                                userNickname: "",
                                activityProductName: "",
                            });
                            this.activityRecord.push({
                                gmtCreate: "",
                                userNickname: "",
                                activityProductName: "",
                            });
                        } else {
                            this.activityRecord.push({
                                gmtCreate: "",
                                userNickname: "",
                                activityProductName: "",
                            });
                        }
                        for (
                            var j = 0;
                            j < this.activityRecord.length;
                            j = j + 3
                        ) {
                            const list = [];
                            list.push(this.activityRecord[j]);
                            list.push(this.activityRecord[j + 1]);
                            list.push(this.activityRecord[j + 2]);
                            this.activityRecordOuter.push(list);
                        }
                    }
                }
            });
        },
        // 暂时使用固定图片轮播
        // getActivityImg () {
        //     getActivityImg(this.activityId).then(res => {
        //         if (res.code === 0) {
        //             this.imgList = res.data.activityProduct
        //             this.$nextTick(() => {
        //                 this.initSwiper()
        //             })
        //         }
        //     })
        // },
        handleRegis() {
            if (this.form.username === "") {
                Notify({
                    type: "warning",
                    message: "请输入手机号",
                });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.username)) {
                Notify({
                    type: "warning",
                    message: "请输入正确的手机号",
                });
                return false;
            }
            if (this.code === "") {
                Notify({
                    type: "warning",
                    message: "请输入图形验证码",
                });
                return;
            }
            if (this.form.checkCode === "") {
                Notify({
                    type: "warning",
                    message: "请输入短信验证码",
                });
                return;
            }
            this.form.registerActivityId = this.activityId;
            fetchLogin(this.form).then((res) => {
                this.$router.push("/inviteRegisterSuccess");
                // this.show = true
            });
        },
        getCode() {
            return fetchCode()
                .then((res) => {
                    console.log(res.data);
                    return (
                        "data:image/gif;base64," +
                        btoa(
                            new Uint8Array(res.data).reduce(
                                (data, byte) =>
                                    data + String.fromCharCode(byte),
                                ""
                            )
                        )
                    );
                })
                .then((data) => {
                    this.imgUrl = data;
                    return data;
                });
        },
        sendMsg() {
            if (this.form.username === "") {
                Notify({
                    type: "warning",
                    message: "请输入手机号",
                });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.username)) {
                Notify({
                    type: "warning",
                    message: "请输入正确的手机号",
                });
                return false;
            }
            if (this.code === "") {
                Notify({
                    type: "warning",
                    message: "请输入图形验证码",
                });
                return;
            }
            if (this.code.length !== 4) {
                Notify({
                    type: "warning",
                    message: "图形验证码长度需为4位",
                });
                return;
            }
            checkPhone({ phone: this.form.username }).then((res) => {
                console.log(res);
                if (res.existFlag.value === 1) {
                    Notify({
                        type: "warning",
                        message: "您已注册，请进入wowotown App体验美好生活",
                    });
                } else {
                    getSmsCaptcha({
                        phone: this.form.username,
                        businessType: "app_user_login",
                        checkCode: this.code,
                    })
                        .then((res) => {
                            Notify({
                                type: "success",
                                message: "验证码已发送，请查看",
                            });
                            this.state.smsSendBtn = true;
                            const interval = window.setInterval(() => {
                                if (this.state.time-- <= 0) {
                                    this.state.time = 60;
                                    this.state.smsSendBtn = false;
                                    window.clearInterval(interval);
                                }
                            }, 1000);
                        })
                        .catch(() => {
                            this.getCode();
                            // this.picCode = ''
                        });
                }
            });
            //
        },
    },
};
</script>

<style lang="less" scoped>
.notice-swipe {
    height: 120px;
}

.longText {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.helpSuccess {
    width: 300px;
    height: 500px;
}

.goToDownload {
    background: url(../assets/renButton1.png) 100% no-repeat;
    color: white;
    font-size: 16px;
    width: 300px;
    height: 50px;
    border: none;
    margin-top: 10px;
}

.button-wrapper {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;

    .van-button {
        height: 40px;
        font-size: 22px;
        letter-spacing: 1px;
        padding: 0;
        width: 166px;
        margin: 80px 80px;

        &.face-invite {
            color: #f93b36;
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(254, 108, 96, 1);
            //border-image: linear-gradient(180deg, rgba(254, 108, 96, 1), rgba(247, 41, 35, 1)) 1 1;
        }

        &.instance-invite {
            background: linear-gradient(180deg, #ff6864 0%, #f82923 100%);
            color: white;
            border-color: #ff6864;
            border-radius: 8px;
            font-size: 16px;
        }
    }
}

.inviteregis-container {
    background: url(../assets/inviteLong.png) top left/100% 100% no-repeat;
    height: 900px;
    width: 100%;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    background-size: 100%;
    .regis-info {
        min-height: calc(100vh - 300px);
        padding: 20px 15px;
        background-size: 170%;
        background-position: center;
        margin-top: 35px;
        .userNamePosition {
            overflow: hidden;
            white-space: nowrap;
            width: 200px;
            text-overflow: ellipsis;
            color: #ef693f;
            font-size: 18px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            margin-top: 25px;
            margin-left: 140px;
        }
        .swiper {
            margin-left: 45px;
            margin-right: 10px;
        }
        #banner {
            margin-left: -35px;
            margin-top: 90px;
        }
        .swiper-slide {
            height: 118%;
            width: 118%;
            text-align: center;
            font-size: 18px;
            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            transition: 300ms;
            transform: scale(0.8);
        }
        .swiper-slide-active,
        .swiper-slide-duplicate-active {
            transform: scale(1.25);
            //box-shadow: rgba(0,0,0,.5);
            -webkit-filter: drop-shadow(
                10px 10px 10px rgba(0, 0, 0, 0.5)
            ); /*考虑浏览器兼容性：兼容 Chrome, Safari, Opera */
            filter: drop-shadow(10px 10px 10px rgba(0, 0, 0, 0.5));
        }

        .swiper-button-next {
            --swiper-navigation-size: 0px;
        }
        .buttonNextTrue {
            margin-top: -370px;
            margin-left: -65px;
        }
        .buttonPrevTrue {
            margin-top: -370px;
            margin-left: 70px;
        }
        .swiper-button-prev {
            --swiper-navigation-size: 0px;
        }
        p {
            margin: 0;

            span {
                display: inline-block;
                font-size: 27px;
                letter-spacing: 2px;
                font-family: PingFang-SC-Heavy, PingFang-SC;
                color: #ffffff;
                line-height: 48px;
                text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
                -webkit-text-stroke: 0 #ffffff;
                text-stroke: 0px #ffffff;

                &.img-position {
                    position: absolute;
                    left: 20px;
                    top: 177px;
                    width: 344px;
                    height: 283px;
                }

                &.gift-position {
                    position: absolute;
                    left: 284px;
                    top: 300px;
                    width: 56px;
                    height: 56px;
                }
            }
        }
    }

    .form-container {
        margin: 100px 10px;
        padding: 0 15px;
        .register-btn {
            width: 100%;
            background: linear-gradient(180deg, #ff6763 0%, #f82a24 100%);
            border-radius: 8px;
            border: none;
            color: #fff;
            font-size: 16px;
        }

        .van-field {
            padding-top: 0;
            padding-bottom: 0;
            border-radius: 8px;
            margin-bottom: 10px;
            line-height: 42px;

            img {
                height: 42px;
            }
        }
    }

    .winningRecordTrue {
        padding: 20px 15px;
        background-size: 100%;
        background-color: #ffeac0;
        border-radius: 8px;
        margin: -70px 15px;
    }

    .winningRecord {
        padding: 20px 15px;
        background-size: 170%;
        background-position: center;
        background-color: #ffeac0;
        border-radius: 8px;
        margin: -60px 15px;
    }

    .list-row {
        padding-bottom: 5px;
    }
}
</style>
